
import {
  AHImageHorizontalCollectionAddItem,
  AHImageHorizontalCollectionItem,
  AHImageHorizontalCollectionStaticSize,
} from "../../../../components";

import { useLightboxControls } from "@/src/common/lightbox/LightboxProvider";
import { View } from "react-native";

export const Images = ({
  taskId,
  images,

  onRemoveImage,
  openImageActionSheet,
  ref,
}: {
  taskId: string;
  images: Image[];

  onRemoveImage: (taskId: string, imageId: string) => void;
  openImageActionSheet(): void;
  ref?: React.RefObject<View | null>;
}) => {
  const lightbox = useLightboxControls();

  return (
    <>
      <AHImageHorizontalCollectionStaticSize size={100} space="medium">
        {images.map((image, i) => (
          <AHImageHorizontalCollectionItem
            shadow="none"
            uri={image.uri}
            type="local"
            key={image.id}
            onPress={() =>
              lightbox.openLightbox({
                images: images.map((img) => ({
                  onDelete() {
                    onRemoveImage(taskId, img.id);
                  },
                  image: {
                    type: "local" as const,
                    uri: img.uri,
                  },
                  dimensions: {
                    width: img.width,
                    height: img.height,
                  },
                  mediaType: "image" as const,
                })),
                index: i,
              })
            }
          />
        ))}
        <AHImageHorizontalCollectionAddItem
          shadow="none"
          ref={ref}
          onPress={openImageActionSheet}
        />
      </AHImageHorizontalCollectionStaticSize>
    </>
  );
};

type Image = { id: string; uri: string; width: number; height: number };
